module.exports = __webpack_public_path__ + "static/img/3.35109d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/management/3.png
// module id = N3we
// module chunks = 7